import { BellRing, CircleMinus, CirclePause, Navigation, Route, WifiOff, type LucideIcon } from 'lucide-react';
import type { IndicadoresFlota as Ind } from '@tms/contratos';
import type { Color } from './estados';

export type ClaveIndicador = 'EN_RUTA' | 'DETENIDA' | 'SIN_REPORTE' | 'SIN_ACTIVIDAD' | 'viajes' | 'alertas';

interface Props {
  indicadores: Ind | null;
  /** Filtro de estado activo, para resaltar el indicador. */
  activo: string;
  onClick: (k: ClaveIndicador) => void;
}

const dos = (n: number) => String(n).padStart(2, '0');

/** Barra de indicadores de la torre. Cada uno es un botón que filtra o navega. */
export function IndicadoresFlota({ indicadores: i, activo, onClick }: Props) {
  const items: { k: ClaveIndicador; icono: LucideIcon; color: Color; n: number | null; etiqueta: string; extra?: string }[] = [
    { k: 'EN_RUTA', icono: Navigation, color: 'green', n: i?.enRuta ?? null, etiqueta: 'Unidades en ruta' },
    { k: 'DETENIDA', icono: CirclePause, color: 'amber', n: i?.detenidas ?? null, etiqueta: 'Unidades detenidas' },
    { k: 'SIN_REPORTE', icono: WifiOff, color: 'red', n: i?.sinReporte ?? null, etiqueta: 'Sin reportar' },
    { k: 'SIN_ACTIVIDAD', icono: CircleMinus, color: 'muted', n: i?.sinActividad ?? null, etiqueta: 'Sin actividad' },
    { k: 'viajes', icono: Route, color: 'muted', n: i?.viajesEnCurso ?? null, etiqueta: 'Viajes en curso' },
    { k: 'alertas', icono: BellRing, color: 'red', n: i?.alertasAbiertas ?? null, etiqueta: 'Alertas abiertas', extra: i ? `${i.alertasCriticas} críticas` : undefined },
  ];
  return (
    <section className="metrics" aria-label="Indicadores de la flota">
      {items.map((m) => {
        const Icono = m.icono;
        return (
          <button key={m.k} type="button" className={`metric ${activo === m.k ? 'active' : ''}`} onClick={() => onClick(m.k)} aria-pressed={activo === m.k}>
            <span className={`metric-icon ${m.color}`}>
              <Icono aria-hidden />
            </span>
            <div>
              <strong>{m.n === null ? '—' : dos(m.n)}</strong>
              <small>{m.etiqueta}</small>
            </div>
            {m.extra && <span className="submetric">{m.extra}</span>}
          </button>
        );
      })}
    </section>
  );
}
